import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT, waHref } from "@/lib/contact";

// Desktop: floating WA bubble bottom-right.
// Mobile: sticky bottom bar (split Call / WhatsApp).
export default function FloatingActions() {
  return (
    <>
      {/* Desktop floating WhatsApp */}
      <motion.a
        data-testid="floating-whatsapp"
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chamar no WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="fixed bottom-6 right-6 z-40 hidden h-16 w-16 items-center justify-center rounded-full bg-brand-green text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform hover:scale-105 active:scale-95 md:inline-flex"
      >
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-brand-green/50" />
        <MessageCircle className="h-7 w-7" strokeWidth={2.5} />
      </motion.a>

      {/* Mobile sticky action bar */}
      <div
        data-testid="mobile-sticky-bar"
        className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-chrome/20 shadow-[0_-8px_20px_rgba(0,0,0,0.4)] md:hidden"
      >
        <a
          data-testid="mobile-call-btn"
          href={CONTACT.telHref}
          className="flex items-center justify-center gap-2 bg-brand-yellow py-4 font-display text-sm uppercase tracking-widest text-black active:bg-yellow-500"
        >
          <Phone className="h-4 w-4" strokeWidth={2.5} />
          LIGAR
        </a>
        <a
          data-testid="mobile-whatsapp-btn"
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-brand-green py-4 font-display text-sm uppercase tracking-widest text-white active:bg-brand-green-dark"
        >
          <MessageCircle className="h-4 w-4" strokeWidth={2.5} />
          WHATSAPP
        </a>
      </div>
    </>
  );
}
